export const LanguageConstants = {
    español: "ES",
}